import React, { useState } from 'react';
import Calendar from './components/Calendar';
import BookingForm from './components/BookingForm';
import './App.css';

function App() {
  const [currentMonth, setCurrentMonth] = useState(new Date()); // Start from today's date
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [availableStayTypes, setAvailableStayTypes] = useState([]);
  const [isBookingFormOpen, setIsBookingFormOpen] = useState(false);

  const handleDateClick = (date, houseKey, stayTypes = []) => {
    setSelectedDate(date);
    setSelectedHouse(houseKey);
    setAvailableStayTypes(stayTypes);
    setIsBookingFormOpen(true);
  };

  const handleCloseBookingForm = () => {
    setIsBookingFormOpen(false);
    setSelectedDate(null);
    setSelectedHouse(null);
  };

  const handleMonthChange = (newMonth) => {
    setCurrentMonth(newMonth);
  };

  return (
    <div className="App">
      <div className="app-container">
        <Calendar 
          onDateClick={handleDateClick}
          currentMonth={currentMonth}
          onMonthChange={handleMonthChange}
        />
        
        <BookingForm 
          isOpen={isBookingFormOpen}
          onClose={handleCloseBookingForm}
          selectedDate={selectedDate}
          selectedHouse={selectedHouse}
          availableStayTypes={availableStayTypes}
        />
      </div>
    </div>
  );
}

export default App;
